"use client";
import { createContext, useContext } from "react";
const PopoverModeContext = createContext('popover');
const usePopoverMode = ()=>useContext(PopoverModeContext);
export { PopoverModeContext, usePopoverMode };
